"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FeedbackUI = _interopRequireDefault(require("./FeedbackUI"));

var _preactCompat = require("preact-compat");

var _phrase = require("@insided/deprecated-libs/translationsUtils/phrase");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isControl = (0, _globals.default)('application') === 'control';

var Feedback = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Feedback, _PureComponent);

  var _super = _createSuper(Feedback);

  function Feedback(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Feedback);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onYesClickHandler", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.save({
                sentiment: 1,
                options: [],
                comment: ''
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNoClickHandler", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(selectedOptions, additionalInfo) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.save({
                  sentiment: -1,
                  options: selectedOptions,
                  comment: additionalInfo
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.fetchPhrases(['hub_ai.feedback.is_this_helpful', 'hub_ai.feedback.thank_you_for_your_feedback', 'hub_ai.feedback.tell_us_more', 'hub_ai.feedback.other', 'hub_ai.feedback.provide_additional_feedback', 'hub_ai.feedback.optional_provide_additional_feedback', 'hub_ai.feedback.field_required', 'hub_ai.feedback.send', 'hub_ai.feedback.save_failed_error']);

    return _this;
  }

  (0, _createClass2.default)(Feedback, [{
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref3) {
        var comment, options, sentiment, _this$props, featureName, topicIds, input, output, documentIds;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                comment = _ref3.comment, options = _ref3.options, sentiment = _ref3.sentiment;
                _this$props = this.props, featureName = _this$props.featureName, topicIds = _this$props.topicIds, input = _this$props.input, output = _this$props.output, documentIds = _this$props.documentIds;
                _context3.next = 4;
                return _axios.default.post('/hub-ai/feedback', {
                  featureName: featureName,
                  sentiment: sentiment,
                  url: document.location.href,
                  comment: comment,
                  options: options,
                  topicIds: topicIds,
                  documentIds: documentIds,
                  input: input,
                  output: output
                });

              case 4:
                return _context3.abrupt("return", _context3.sent);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function save(_x3) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "fetchPhrases",
    value: function () {
      var _fetchPhrases = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(phrasesSet) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Promise.all(phrasesSet.map( /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(p) {
                    return _regenerator.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return new Promise(function (resolve) {
                              return (0, _phrase.fetchPhrase)('Forum', p, function (phrs) {
                                return resolve(phrs);
                              });
                            });

                          case 2:
                            return _context4.abrupt("return", _context4.sent);

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function fetchPhrases(_x4) {
        return _fetchPhrases.apply(this, arguments);
      }

      return fetchPhrases;
    }()
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(_FeedbackUI.default, (0, _extends2.default)({
        onLike: this.onYesClickHandler,
        onDislike: this.onNoClickHandler
      }, this.props, {
        isControl: isControl
      }));
    }
  }]);
  return Feedback;
}(_preactCompat.PureComponent);

exports.default = Feedback;